import { RawOrderHistory } from 'app/types/orders'

const name = 'order-history-state'

export const FETCH_ORDER_HISTORY_REQUEST = `${name}/FETCH_ORDER_HISTORY_REQUEST`
export const FETCH_ORDER_HISTORY_SUCCESS = `${name}/FETCH_ORDER_HISTORY_SUCCESS`
export const FETCH_ORDER_HISTORY_ERROR = `${name}/FETCH_ORDER_HISTORY_ERROR`

export const CLEAR_ORDER_HISTORY = 'CLEAR_ORDER_HISTORY'

export const FETCH_ORDER_DETAILS_REQUEST = 'FETCH_ORDER_DETAILS_REQUEST'
export const FETCH_ORDER_DETAILS_SUCCESS = 'FETCH_ORDER_DETAILS_SUCCESS'
export const FETCH_ORDER_DETAILS_ERROR = 'FETCH_ORDER_DETAILS_ERROR'

export const ADD_RETURN = 'ADD_RETURN'
export const CLEAR_RETURN = 'CLEAR_RETURN'
export const CLEAR_ALL_RETURNS = 'CLEAR_ALL_RETURNS'

export const CREATE_RETURN_REQUEST = 'CREATE_RETURN_REQUEST'
export const CREATE_RETURN_SUCCESS = 'CREATE_RETURN_SUCCESS'
export const CREATE_RETURN_ERROR = 'CREATE_RETURN_ERROR'

export const FETCH_RETURN_LABEL_REQUEST = 'FETCH_RETURN_LABEL_REQUEST'
export const FETCH_RETURN_LABEL_SUCCESS = 'FETCH_RETURN_LABEL_SUCCESS'
export const FETCH_RETURN_LABEL_ERROR = 'FETCH_RETURN_LABEL_ERROR'
export const CLEAR_RETURN_LABEL = 'CLEAR_RETURN_LABEL'

export const SELECT_PRODUCT_COLOUR = 'SELECT_PRODUCT_COLOUR'
export const SELECT_RETURN_CODE = 'SELECT_RETURN_CODE'
export const SELECT_RETURN_OR_EXCHANGE = 'SELECT_RETURN_OR_EXCHANGE'

export type OrderHistoryCategory = 'recent' | 'past'
export type OrderHistoryAction =
  | { type: typeof FETCH_ORDER_HISTORY_REQUEST; payload: { category: OrderHistoryCategory } }
  | { type: typeof FETCH_ORDER_HISTORY_SUCCESS; payload: { category: OrderHistoryCategory, data: RawOrderHistory, clearState: boolean } }
  | { type: typeof FETCH_ORDER_HISTORY_ERROR; payload: { category: OrderHistoryCategory } }
  | { type: typeof CLEAR_ORDER_HISTORY, payload: OrderHistoryCategory }